import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';

interface GoogleLoginButtonProps {
  onSuccess: (tokenResponse: any) => Promise<void>;
  onError: () => void;
  className?: string;
  children: React.ReactNode;
}

/**
 * This component MUST only be rendered when GoogleOAuthProvider is present.
 * The parent component should check for GOOGLE_CLIENT_ID before rendering this.
 */
export const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ 
  onSuccess, 
  onError,
  className,
  children,
}) => {
  const handleGoogleLogin = useGoogleLogin({
    onSuccess,
    onError,
  });
  
  return (
    <button className={className} onClick={() => handleGoogleLogin()}>
      {children}
    </button>
  );
};

export default GoogleLoginButton;
